import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import PriceRowPriceLoadingSkeleton from '../PriceRowPriceLoadingSkeleton'
import PriceRowPointsSpendLoadingSkeleton from '../PriceRowPointsSpendLoadingSkeleton'
import Group from 'components/utils/Group'

interface Props {
  size: 'S' | 'L'
  direction: 'horizontal' | 'stack'
}

function PriceRowMerchandisePriceStackingLoadingSkeleton(props: Props) {
  const { size, direction } = props

  return <Group
    direction={direction === 'horizontal' ? 'horizontal' : 'vertical'}
    gap={direction === 'horizontal' ? 8 : 0}
    verticalAlign={direction === 'horizontal' ? 'start' : undefined}
  >
    <PriceRowPriceLoadingSkeleton size={size} saleUnit={false} />
    <Group direction="horizontal" gap={8} verticalAlign="start">
      <TextLoadingBox typography="body-small" width="2ch" />
      <PriceRowPointsSpendLoadingSkeleton size={size} />
    </Group>
  </Group>
}

export default PriceRowMerchandisePriceStackingLoadingSkeleton
